enum MeasurementType {
    STATE_OF_CHARGE,
    REMAINING_RANGE,
    ENERGY_LEVEL,
    DRIVING_STATE,
    CHARGING_STATE,
}

export default MeasurementType;
